import styled from "styled-components";

export const AddConditionStyles = styled.div`
  margin: 14px 0 0 0;
`;
